import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Toimitus',
    pickup: 'Nouto',
    room_service: 'Paikan päällä',
    table_service: 'Paikan päällä',
  },
  asap: 'Heti',
  unavailable: 'Ei saatavilla',
  ready_in_time: 'Valmis {{time}} min kuluttua',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Toimitus osoitteeseen {{address}}',
    [ORDER_METHODS.PICKUP]: 'Nouto osoitteesta {{address}}',
    [ORDER_METHODS.ROOM_SERVICE]: 'Paikan päällä osoitteessa {{address}}',
  },
  buttons: {
    change: 'Vaihda',
    see_hours: 'Katso aukioloajat',
    change_location: 'Vaihda sijaintia',
    change_time: 'Vaihda aikaa',
  },
};
